export const createReview = async (payload, apiCall) => {
  try {
    const response = await apiCall('/api/reviews/create', {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
      const errorMessage = data.errors?.[0]?.msg || data.message || `Error: ${response.status}`;
      throw new Error(errorMessage);
    }

    return { success: true, data: data.data };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Create review error:', error.message);
    }
    
    return {
      success: false,
      error: error.message || 'Failed to submit review. Please try again.'
    };
  }
};

export const fetchDraftReviews = async (apiCall, draftId, cursor = null) => {
  try {
    const params = new URLSearchParams();
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/reviews/draft/${draftId}?${params.toString()}`);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      reviews: data.reviews || [],
      nextCursor: data.nextCursor || null,
      hasMore: data.hasMore || false
    };
  } catch (error) {
    throw error;
  }
};

export const deleteReview = async (apiCall, reviewId) => {
  try {
    const response = await apiCall(`/api/reviews/${reviewId}`, {
      method: 'DELETE',
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
      throw new Error(data.message || `Error: ${response.status}`);
    }

    return { success: true };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Delete review error:', error.message);
    }
    
    return {
      success: false,
      error: error.message || 'Failed to delete review. Please try again.'
    };
  }
};